import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useLeadStore = create(
  persist(
    (set, get) => ({
      // State
      selectedLead: null,
      leads: [],
      isLoading: false,
      error: null,

      filters: {
        propertyId: null,
        status: null,
        source: null,
      },

      sortBy: "createdAt",
      sortOrder: "desc",

      // Actions
      setSelectedLead: (lead) =>
        set({ selectedLead: lead }),

      setLeads: (leads) =>
        set({ leads }),

      setLoading: (isLoading) =>
        set({ isLoading }),

      setError: (error) =>
        set({ error }),

      setFilters: (filters) =>
        set({
          filters: {
            ...get().filters,
            ...filters,
          },
        }),

      setSortBy: (sortBy) =>
        set({ sortBy }),

      setSortOrder: (sortOrder) =>
        set({ sortOrder }),

      clearSelectedLead: () =>
        set({ selectedLead: null }),

      clearFilters: () =>
        set({
          filters: {
            propertyId: null,
            status: null,
            source: null,
          },
        }),

      // Computed
      getFilteredAndSortedLeads: () => {
        const {
          leads,
          filters,
          sortBy,
          sortOrder,
        } = get();

        let filtered = leads.filter(
          (lead) => {
            if (
              filters.propertyId &&
              !lead.propertyIds?.includes(
                filters.propertyId
              )
            )
              return false;

            if (
              filters.status &&
              lead.status !== filters.status
            )
              return false;

            if (
              filters.source &&
              lead.source !== filters.source
            )
              return false;

            return true;
          }
        );

        filtered.sort((a, b) => {
          const aVal = a[sortBy];
          const bVal = b[sortBy];

          if (sortOrder === "asc") {
            return aVal > bVal ? 1 : -1;
          }

          return aVal < bVal ? 1 : -1;
        });

        return filtered;
      },
    }),
    {
      name: "lead-storage",

      partialize: (state) => ({
        selectedLead: state.selectedLead,
      }),
    }
  )
);